import React, { useEffect } from "react";

import "./MovieSlider.scss";

const MovieSlider = (props) => {
  useEffect(() => {
    document.getElementById(
      "mover1"
    ).style.backgroundImage = `url(${props.movieSlider.imageUrl})`;
  }, [props.movieSlider.imageUrl]);
  return (
    <div className="movie-slider-main">
      <div className="tech-slideshow">
        <div className="mover-1" id="mover1"></div>
      </div>
    </div>
  );
};

export default MovieSlider;
